<template>
  <tr>
    <td class="pa-0">
      <div class="my-5 px-3">
        <v-alert
          v-if="!valid && value.deskripsi && titleWarning"
          icon="mdi-alert"
          border="left"
          colored-border
          type="warning"
          class="bg-notif"
          dense
        >
          {{ titleWarning }}</v-alert
        >
        <div class="subtitle-1 font-weight-medium mb-2">{{ pertanyaan }}</div>
        <div>
          <p
            v-if="value.deskripsi"
            v-html="$stringToHtml($getDeepObj(value, 'deskripsi'))"
            class="grey--text text--darken-3"
          ></p>
          <em v-else class="grey--text">Belum ada jawaban</em>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { currency } from '@utils/format';

export default {
  name: 'ViewData',
  props: {
    type: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      default: () => {},
    },
    valid: {
      type: Boolean,
      default: false,
    },
    pertanyaan: {
      type: String,
      default: '',
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    titleWarning() {
      const str = this.value && this.value.deskripsi;
      const kata = this.$wordCount(str);
      let result = '';
      if (this.max && kata >= this.max) {
        result = `Isian esai yang anda isi melebihi ${currency(this.max)} Kata`;
      } else if (kata < this.min) {
        result = `Isian esai yang anda isi kurang ${this.min - kata} Kata`;
      }

      return result;
    },
  },
  methods: {
    onEdit(type) {
      this.$emit('edit', { type: type });
    },
  },
};
</script>

<style scoped>
.bg-info {
  background-color: #ffb74d !important;
}
</style>
